// Auto Translate Action Types - General
export const AUTO_TRANSLATE_REQUEST = "AUTO_TRANSLATE_REQUEST";
export const AUTO_TRANSLATE_SUCCESS = "AUTO_TRANSLATE_SUCCESS";
export const AUTO_TRANSLATE_FAILURE = "AUTO_TRANSLATE_FAILURE";
export const AUTO_TRANSLATE_RESET = "AUTO_TRANSLATE_RESET";

// Campaign Auto Translate
export const CAMPAIGN_AUTO_TRANSLATE_REQUEST =
  "CAMPAIGN_AUTO_TRANSLATE_REQUEST";
export const CAMPAIGN_AUTO_TRANSLATE_SUCCESS =
  "CAMPAIGN_AUTO_TRANSLATE_SUCCESS";
export const CAMPAIGN_AUTO_TRANSLATE_FAILURE =
  "CAMPAIGN_AUTO_TRANSLATE_FAILURE";

// Hotel Auto Translate
export const HOTEL_AUTO_TRANSLATE_REQUEST = "HOTEL_AUTO_TRANSLATE_REQUEST";
export const HOTEL_AUTO_TRANSLATE_SUCCESS = "HOTEL_AUTO_TRANSLATE_SUCCESS";
export const HOTEL_AUTO_TRANSLATE_FAILURE = "HOTEL_AUTO_TRANSLATE_FAILURE";

export const ROOM_TYPE_AUTO_TRANSLATE_REQUEST =
  "ROOM_TYPE_AUTO_TRANSLATE_REQUEST";
export const ROOM_TYPE_AUTO_TRANSLATE_SUCCESS =
  "ROOM_TYPE_AUTO_TRANSLATE_SUCCESS";
export const ROOM_TYPE_AUTO_TRANSLATE_FAILURE =
  "ROOM_TYPE_AUTO_TRANSLATE_FAILURE";

// Tour Auto Translate
export const TOUR_AUTO_TRANSLATE_REQUEST = "TOUR_AUTO_TRANSLATE_REQUEST";
export const TOUR_AUTO_TRANSLATE_SUCCESS = "TOUR_AUTO_TRANSLATE_SUCCESS";
export const TOUR_AUTO_TRANSLATE_FAILURE = "TOUR_AUTO_TRANSLATE_FAILURE";

// Tour Ticket Auto Translate
export const TOUR_TICKET_AUTO_TRANSLATE_REQUEST =
  "TOUR_TICKET_AUTO_TRANSLATE_REQUEST";
export const TOUR_TICKET_AUTO_TRANSLATE_SUCCESS =
  "TOUR_TICKET_AUTO_TRANSLATE_SUCCESS";
export const TOUR_TICKET_AUTO_TRANSLATE_FAILURE =
  "TOUR_TICKET_AUTO_TRANSLATE_FAILURE";

// Supplier Auto Translate
export const SUPPLIER_AUTO_TRANSLATE_REQUEST =
  "SUPPLIER_AUTO_TRANSLATE_REQUEST";
export const SUPPLIER_AUTO_TRANSLATE_SUCCESS =
  "SUPPLIER_AUTO_TRANSLATE_SUCCESS";
export const SUPPLIER_AUTO_TRANSLATE_FAILURE =
  "SUPPLIER_AUTO_TRANSLATE_FAILURE";

// Menu Auto Translate
export const MENU_AUTO_TRANSLATE_REQUEST = "MENU_AUTO_TRANSLATE_REQUEST";
export const MENU_AUTO_TRANSLATE_SUCCESS = "MENU_AUTO_TRANSLATE_SUCCESS";
export const MENU_AUTO_TRANSLATE_FAILURE = "MENU_AUTO_TRANSLATE_FAILURE";

// Tag Group Detail Auto Translate
export const TAG_GROUP_DETAIL_AUTO_TRANSLATE_REQUEST =
  "TAG_GROUP_DETAIL_AUTO_TRANSLATE_REQUEST";
export const TAG_GROUP_DETAIL_AUTO_TRANSLATE_SUCCESS =
  "TAG_GROUP_DETAIL_AUTO_TRANSLATE_SUCCESS";
export const TAG_GROUP_DETAIL_AUTO_TRANSLATE_FAILURE =
  "TAG_GROUP_DETAIL_AUTO_TRANSLATE_FAILURE";

// VinWonder Tag Group Auto Translate
export const VINWONDER_TAG_GROUP_AUTO_TRANSLATE_REQUEST =
  "VINWONDER_TAG_GROUP_AUTO_TRANSLATE_REQUEST";
export const VINWONDER_TAG_GROUP_AUTO_TRANSLATE_SUCCESS =
  "VINWONDER_TAG_GROUP_AUTO_TRANSLATE_SUCCESS";
export const VINWONDER_TAG_GROUP_AUTO_TRANSLATE_FAILURE =
  "VINWONDER_TAG_GROUP_AUTO_TRANSLATE_FAILURE";

// Rate Auto Translate
export const RATE_AUTO_TRANSLATE_REQUEST = "RATE_AUTO_TRANSLATE_REQUEST";
export const RATE_AUTO_TRANSLATE_SUCCESS = "RATE_AUTO_TRANSLATE_SUCCESS";
export const RATE_AUTO_TRANSLATE_FAILURE = "RATE_AUTO_TRANSLATE_FAILURE";

// Rate Plan Auto Translate
export const RATE_PLAN_AUTO_TRANSLATE_REQUEST =
  "RATE_PLAN_AUTO_TRANSLATE_REQUEST";
export const RATE_PLAN_AUTO_TRANSLATE_SUCCESS =
  "RATE_PLAN_AUTO_TRANSLATE_SUCCESS";
export const RATE_PLAN_AUTO_TRANSLATE_FAILURE =
  "RATE_PLAN_AUTO_TRANSLATE_FAILURE";

// Bookable Package Rate Auto Translate
export const BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_REQUEST =
  "BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_REQUEST";
export const BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_SUCCESS =
  "BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_SUCCESS";
export const BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_FAILURE =
  "BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE_FAILURE";
